import { Outlet, Route } from '@tanstack/router'

import { rootRoute } from '../root'

export const newsRoute = new Route({
  getParentRoute: () => rootRoute,
  path: 'news',
  component: Outlet,
})
